import { Component, SDK, deserialize } from '@redge-media/fo-js-sdk';

const EmbeddedWhitelist = Component.mixin({ deserialize }).extend({
  method: 'get',

  constructor: function EmbeddedWhitelist(opts = {}) {
    Component.call(this);

    this.id = opts.id;
  },

  getPath() {
    return `/products/${this.id}/whitelist`;
  },

  fetch(opts = {}) {
    return SDK.apiAdapter[this.method](this.getPath()).then((response) => {
      return this.deserialize(response, opts);
    });
  },
});

export default EmbeddedWhitelist;
